import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.scss';

const Navigation: React.FC = () => {
  const [scrolled, setScrolled] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = (): void => {
      setScrolled(window.pageYOffset > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-content">
        <div className="nav-links">
          <Link className="nav-link" to="/auth/login">
            SIGN IN
          </Link>
          <a href="https://apps.apple.com/us/app/sgt-docket-rocket/id6499451413" className="nav-link">DOWNLOAD</a>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;

